// React imports
import React from 'react';
import classnames from 'classnames';
import { CmAlertDialog } from '@codametrix/ui-components';
import './styles/index.scss';
/**
 * State for the Case Exclusion component
 */
type CaseExclusionState = {
  comment: string;
};

class CaseExclusion extends React.Component<
  Accelerate.CaseExclusionProps,
  CaseExclusionState
> {
  static displayName = 'CaseExclusion';
  /**
   * Constructor method for class CaseExclusion
   * @param {Accelerate.CaseExclusionProps} props
   */
  private cancelButtonRef = React.createRef<HTMLButtonElement>();

  constructor(props: Accelerate.CaseExclusionProps) {
    super(props);
    this.state = {
      comment: ''
    };
    this.caseToggleExclusion = this.caseToggleExclusion.bind(this);
    this.cancelExclusion = this.cancelExclusion.bind(this);
    this.handleCommentChange = this.handleCommentChange.bind(this);
  }

  static defaultProps = {
    isChargeable: false,
    onStandaloneLaunch: () => {},
    onEmbeddedLaunch: () => {}
  };

  /**
   * Method to handle the change event for text area element
   * @param {Object} event - Event object
   */
  handleCommentChange(event) {
    this.setState({ comment: event.target.value });
  }

  /**
   * Method for case exclusion
   */
  caseToggleExclusion() {
    this.props.onCaseExclusion(this.state.comment);
  }

  /**
   * Method for cancel the exclusion of a case
   */
  cancelExclusion() {
    this.props.onCancel();
  }

  render() {
    return (
      <CmAlertDialog
        isOpen={true}
        onClose={this.cancelExclusion}
        title={this.props.title}
        leastDestructiveRef={this.cancelButtonRef}
        footer={
          <>
            <button
              ref={this.cancelButtonRef}
              type="button"
              onClick={this.cancelExclusion}
              className="chakra-secondary-button">
              No, Cancel
            </button>
            <button
              type="button"
              onClick={this.caseToggleExclusion}
              className={classnames('chakra-primary-button')}>
              {this.props?.isChargeable
                ? 'Yes, exclude case'
                : 'Yes, include case'}
            </button>
          </>
        }>
        <form className="case-exclusion" onSubmit={e => e.preventDefault()}>
          <p className="case-exclusion-subtitle">
            {this.props?.isChargeable
              ? 'This case will be considered non-chargeable, will be kept for reference, and charges are not submitted for billing. You can reverse this at any time.'
              : 'This case will be considered chargeable. You will be able to code and submit for billing. You can reverse this any time before the case is submitted.'}
          </p>

          {/* Text area for comment was commented meanwhile in the future comments feature is added */}
          {/* <textarea
          className="case-exclusion-comment cmx-form-input input"
          placeholder="Enter comments (required)"
          maxLength={1024}
          onChange={this.handleCommentChange}
          rows={4}></textarea> */}
        </form>
      </CmAlertDialog>
    );
  }
}

export { CaseExclusion };
